import React from 'react';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import services from '../../../../../services'

const DadosFinanceirosSeller = ({ setDadosBancarios, indexPosition, dadosFinanceiros }) => {
    return (
        <div>
            <div className='row mt5'>
                <div className='col-md-2 col-sm-2 col-lg-2 ml-1'>
                    <FormGroup>
                        <FormControlLabel control={<Checkbox checked={dadosFinanceiros[indexPosition].principal ? true : false} onChange={event => setDadosBancarios(event.target.checked, 'principal', indexPosition)} />} label="Principal" size="small" />
                    </FormGroup>
                </div>

            </div>

            <div className="row mt5">
                <div className='col-md-4 col-sm-4 col-lg-4'>
                    <FormControl >
                        <TextField fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="Banco"
                            inputProps={{ maxLength: 40 }}
                            size="small"
                            value={dadosFinanceiros[indexPosition].banco}
                            onChange={event => setDadosBancarios(event.target.value, 'banco', indexPosition)}
                            /* value={usuario?.nome || ''} */
                            /* helperText={isFormInvalid && !usuario?.nome && 'Campo obrigatório'}
                            error={isFormInvalid && !usuario?.nome ? true : false}  *//>
                    </FormControl>
                </div>
                <div className='col-md-4 col-sm-4 col-lg-4'>
                    <FormControl >
                        <TextField fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="Agência"
                            inputProps={{ maxLength: 5 }}
                            size="small"
                            value={services.mask.number(dadosFinanceiros[indexPosition].agencia)}
                            onChange={event => setDadosBancarios(event.target.value, 'agencia', indexPosition)}
                            /* value={usuario?.nome || ''}
                            helperText={isFormInvalid && !usuario?.nome && 'Campo obrigatório'}
                            error={isFormInvalid && !usuario?.nome ? true : false}  */ />
                    </FormControl>
                </div>
                <div className='col-md-4 col-sm-4 col-lg-4'>
                    <FormControl >
                        <TextField fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="C/C"
                            inputProps={{ maxLength: 20 }}
                            size="small"
                            value={services.mask.number(dadosFinanceiros[indexPosition].conta)}
                            onChange={event => setDadosBancarios(event.target.value, 'conta', indexPosition)}
                           /*  value={usuario?.nome || ''}
                            helperText={isFormInvalid && !usuario?.nome && 'Campo obrigatório'}
                            error={isFormInvalid && !usuario?.nome ? true : false} */ />
                    </FormControl>
                </div>
            </div>
        </div>
    )
}

export default DadosFinanceirosSeller;